import { css } from 'styled-components';
import _ from 'lodash';
import { fontFamilyVariables, colorVariables, fontVariables } from 'theme/variables';

const base = css`
  font-family: ${fontFamilyVariables.din_regular};
  display: inline-block;
  text-decoration: none;
  cursor: pointer;
  transition: color 135ms ease-in, background-color 135ms ease-in, opacity 135ms ease-in;
  ${(props) => css`
    text-transform: ${props.transform ? props.transform : 'none'};
    color: ${props.color ? _.get(colorVariables, props.color) : colorVariables.blue_doger};
    font-size: ${props.size ? _.get(fontVariables, props.size) : 'inherit'};
  `};

  &:hover {
    transition: color 135ms ease-out, background-color 135ms ease-out, opacity 135ms ease-out;
    ${(props) => css`
      color: ${props.hover ? _.get(colorVariables, props.hover) : colorVariables.blue_navyblue};
    `};
  }
`;

export default base;
